<template>
  <v-card>
    <v-card-title primary-title>
      <!-- Company view title -->
      <div v-if="userRoleInCompany >= DEFINES.ROLE_ADMIN">
        <div class="headline secondary--text">
          {{ $t("screener.monetization.revenue.company_view.title") }}
        </div>
        <span class="body-1 greyDarken1--text"
          >{{
            $t("screener.monetization.revenue.company_view.subtitle")
          }}</span
        >
      </div>
      <!-- Right holder view title -->
      <div v-if="userRoleInCompany == DEFINES.ROLE_RIGHT_HOLDER">
        <div class="headline secondary--text">
          {{ $t("screener.monetization.revenue.right_holder_view.title") }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t("screener.monetization.revenue.right_holder_view.subtitle")
        }}</span>
      </div>
      <v-alert
          v-if="userRoleInCompany == DEFINES.ROLE_RIGHT_HOLDER"
          :value="true"
          color="error"
          icon="priority_high"
          outline
      >
        {{$t('screener.monetization.revenue.right_holder.notice')}}
      </v-alert>
      <v-spacer></v-spacer>
    </v-card-title>
    <div>
      <!-- Revenue display for company owner & admin -->
      <template v-if="userRoleInCompany >= DEFINES.ROLE_ADMIN">
        <v-tabs
          v-model="currentRevenueTab"
          color="grey lighten-4"
          slider-color="primary"
          grow
        >
          <!-- Screening wise revenue tab  -->
          <v-tab href="#screening_wise_revenue">{{
            $t("screener.monetization.revenue.screening_wise_revenue.title")
          }}</v-tab>
          <!-- Film wise revenue tab -->
          <v-tab href="#film_wise_revenue">{{
            $t("screener.monetization.revenue.film_wise_revenue.title")
          }}</v-tab>
          <!-- Revenue Summary Tab -->
          <v-tab href="#revenue_summary">Revenue Summary</v-tab>
        </v-tabs>
        <v-tabs-items v-model="currentRevenueTab">
          <v-tab-item value="screening_wise_revenue">
            <ScreeningWiseRevenue
              v-if="currentRevenueTab == 'screening_wise_revenue'"
            ></ScreeningWiseRevenue
          ></v-tab-item>
          <v-tab-item value="film_wise_revenue">
            <FilmWiseRevenue
              v-if="currentRevenueTab == 'film_wise_revenue'"
              :isCompanyView="true"
            >
            </FilmWiseRevenue>
          </v-tab-item>
          <v-tab-item value="revenue_summary">
            <RevenueSummary
              class="pa-3"
              v-if="currentRevenueTab == 'revenue_summary'"
            ></RevenueSummary>
          </v-tab-item>
        </v-tabs-items>
      </template>
      <!-- Revenue display for a right holder -->
      <template v-if="userRoleInCompany == DEFINES.ROLE_RIGHT_HOLDER">
        <FilmWiseRevenue></FilmWiseRevenue>
      </template>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ScreeningWiseRevenue from "@/components/revenue/ScreeningWiseRevenue";
import FilmWiseRevenue from "@/components/revenue/FilmWiseRevenue";
import RevenueSummary from "@/components/revenue/RevenueSummary";

export default {
  name: "RevenueList",
  data() {
    return {
      currentRevenueTab: "screening_wise_revenue",
    };
  },
  components: {
    ScreeningWiseRevenue,
    FilmWiseRevenue,
    RevenueSummary,
  },
  computed: {
    ...mapGetters({
      selected_company_id: "company/getSelected",
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
  },
};
</script>

<style></style>
